import { render, staticRenderFns } from "./outboundInfoQuery.vue?vue&type=template&id=c588a154&scoped=true&"
import script from "./outboundInfoQuery.vue?vue&type=script&lang=js&"
export * from "./outboundInfoQuery.vue?vue&type=script&lang=js&"
import style0 from "./outboundInfoQuery.vue?vue&type=style&index=0&id=c588a154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c588a154",
  null
  
)

export default component.exports